<template>
  <div id="tryoutgroup-form">
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/paket-mapel'}">Paket Mata Pelajaran</router-link>
      </li>
      <li class="active">Tambah Paket Mata</li>
    </ol>
    <!-- begin page-header -->
    <h1 class="page-header">Tambah Paket Mata Pelajaran</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Paket Mata Pelajaran</h4>
          </div>
          <div class="panel-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Judul</label>
                  <div class="col-md-8 col-xs-12">
                      <input type="text" class="form-control" v-model="name">
                  </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Jenjang *</label>
                    <div class="col-md-2 col-xs-2">
                        <select class="form-control" v-model="jenjang" @change="resetKelas()">
                            <option v-for="item in jenjangList" v-bind:key="item">{{item}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group" v-if="jenjang">
                    <label class="col-md-2 control-label">Kelas *</label>
                    <div class="col-md-2 col-xs-2">
                      <div v-if="jenjang === 'SD'">
                        <select class="form-control" v-model="kelas">
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMP'">
                        <select class="form-control" v-model="kelas">
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMA'">
                        <select class="form-control" v-model="kelas">
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                        </select>
                      </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Peminatan *</label>
                    <div class="col-md-2 col-xs-2">
                        <select class="form-control" v-model="interest">
                            <option value="DEFAULT">ALL</option>
                            <option value="SAINTEK" v-if="kelas >= 10">IPA</option>
                            <option value="SOSHUM" v-if="kelas >= 10">IPS</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Semester</label>
                  <div class="col-md-2 col-xs-2">
                    <select class="form-control" v-model="semester">
                        <option value="GANJIL">Ganjil</option>
                        <option value="GENAP">Genap</option>
                        <option value="GANJILGENAP">Ganjil Genap</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Kurikulum</label>
                  <div class="col-md-4 col-xs-4">
                    <select class="form-control" v-model="kurikulum">
                        <option v-for="(item,index) in kurikulumList" v-bind:key="index" :value="item.id">{{item.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Mata Pelajaran</label>
                  <div class="col-md-4 col-xs-4">
                    <select class="form-control" v-model="mapel">
                        <option v-for="(item,index) in mapelList" v-bind:key="index" :value="item">{{item.nama}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Initialize Content</label>
                  <div class="col-md-6 col-xs-6">
                    <input type="checkbox" v-model="isInitContent"><br><br>
                    <strong>(Optional)</strong> Dengan mencentang opsi ini maka sistem akan mengisi kontent video dan bank soal
                    secara otomatis berdasarkan kelas dan mata pelajaran yang dipilih.
                  </div>
                </div>
              </div>
            </form>
            <hr />
            <div class="pull-right">
                <button v-if="!$route.params.id" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
                <button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import Spinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'
import moment from 'moment'
import axios from 'axios'
import BimbelService from '@/services/bimbel.js'

export default {
  name: 'mapel-form',
  components: {
    'app-spinner': Spinner,
    'app-modal': Modal
  },
  data: function() {
    return {
      isInitContent: false,
      isLoading: false,
      showModal: false,
      errors: [],
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1,2,3,4,5,6,7,8,9,10,11,12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      kurikulumList: JSON.parse(localStorage.getItem('kurikulum')),
      jenjang: null,
      interest: 'DEFAULT'
    }
  },
  computed: {
    name: {
      get: function() {
        return this.$store.state.bimbel.mapel_name
      },
      set: function(value) {
        this.$store.commit('bimbel_set_mapel_name', value)
      }
    },
    kelas: {
      get: function() {
        return this.$store.state.bimbel.mapel_grade
      },
      set: function(value) {
        this.$store.commit('bimbel_set_mapel_grade', value)
      }
    },
    mapel: {
      get: function() {
        return this.$store.state.bimbel.mapel_mapel
      },
      set: function(value) {
        this.$store.commit('bimbel_set_mapel_mapel', value)
      }
    },
    semester: {
      get: function() {
        return this.$store.state.bimbel.mapel_semester
      },
      set: function(value) {
        this.$store.commit('bimbel_set_mapel_semester', value)
      }
    },
    kurikulum: {
      get: function() {
        return this.$store.state.bimbel.mapel_kurikulum
      },
      set: function(value) {
        this.$store.commit('bimbel_set_mapel_kurikulum', value)
      }
    }
  },
  methods: {
    resetKelas() {
      this.kelas = []
      this.interest = 'ALL'
    },
    validateForm: function() {
      this.errors = []
      if (this.name == '') this.errors.push('Judul wajib diisi')
      if (this.jenjang == null) this.errors.push('Jenjang wajib diisi')
      if (this.kelas == '') this.errors.push('Kelas wajib diisi')
      if (this.kurikulum == '') this.errors.push('kurikulum wajib diisi')
      if (this.semester == '') this.errors.push('Semester wajib diisi')
      if (this.mapel == '') this.errors.push('Mata Pelajaran wajib diisi')
      return this.errors.length == 0
    },
    saveData: function() {
      if (!this.validateForm()) {
        return
      }
        this.isLoading = true
        var context = this
        var body = {
            name : this.name,
            semester : this.semester,
            mapel_id : this.mapel.id,
            mapel_code : this.mapel.code,
            mapel_name : this.mapel.nama,
            mapel_picture : this.mapel.picture,
            jenjang : this.jenjang,
            grade : this.kelas,
            curriculum_id : this.kurikulum,
            interest: this.interest,
            init_content: this.isInitContent
        }

        if (this.isInitContent) {
          BimbelService.initializeBlockPackage( body, function(result) {
            context.isLoading = false
            context.$store.commit('mapel_reset', result.data)
            context.$router.push({path: '/paket-mapel'})
          })
        } else {
          BimbelService.addMapelPackage( body, function(result) {
            context.isLoading = false
            context.$store.commit('mapel_reset', result.data)
            context.$router.push({path: '/paket-mapel'})
          })
        }
    },
    editData: function() {
      if (!this.validateForm()) {
        return
      }
        this.isLoading = true
        var context = this
        var body = {
            name : this.name,
            semester : this.semester,
            mapel_id : this.mapel.id,
            mapel_code : this.mapel.code,
            mapel_name : this.mapel.nama,
            mapel_picture : this.mapel.picture,
            jenjang : this.jenjang,
            grade : this.kelas,
            interest: this.interest,
            curriculum_id : this.kurikulum
        }
        BimbelService.editMapelPackage([body, this.$route.params.id], function(result) {
          context.isLoading = false
          context.$store.commit('mapel_reset', result.data)
          context.$router.push({path: '/paket-mapel'})
        })
    },
  },
  mounted: function () {
    var context = this

    if(this.$route.params.id){
     var context = this
     this.changeUrl = false
     BimbelService.getMapelDetailById( this.$route.params.id, function(result) {
        context.name = result.data.name
        context.jenjang = result.data.jenjang
        context.kelas = result.data.grade
        context.semester = result.data.semester
        context.interest = result.interest

        var kurikulumWrap = context.kurikulumList.find(function(element) {
          return element.name == result.data.curriculum
        })
        context.kurikulum = kurikulumWrap.id
        var mapelWrap = context.mapelList.find(function(element) {
          return element.id == result.data.mapel_id
        })
        context.mapel = mapelWrap
      })
    } else {
      context.name = ''
      context.jenjang = null
      context.kelas = ''
      context.kurikulum = ''
      context.semester = ''
      context.mapel = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?edfd4ab0